module.exports = __webpack_public_path__ + "img/大风子.5eab6c51.jpg";